

































































































































































































































































































































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import Moveable from "vue-moveable";
import { ResizeObserver } from "vue-resize";
import BaseGifPlayer from "@/app/shared/components/base/BaseGifPlayer.vue";
import BaseAnimation from "@/app/shared/components/base/BaseAnimation.vue";

export default Vue.extend({
  name: "MoveableOverlaysControlContainer",
  components: {
    Moveable,
    ResizeObserver,
    BaseGifPlayer,
    BaseAnimation,
  },
  props: {
    hidden: {
      type: Boolean,
      default: false,
    },
    overlays: {
      type: Array,
      required: true,
    },
    isBackside: {
      type: Boolean,
      default: false,
    },
    isPlaying: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      overlayObjectsControlRect: { width: 0, height: 0 },
      mounted: false,
      textOutline: "none",
      textEditMode: false,
      lastCursorPosition: { x: 0, y: 0 },
      scaleXBefore: 1,
      scaleYBefore: 1,
      translateXBefore: 0,
      translateYBefore: 0,
      clientXBefore: 0,
      clientYBefore: 0,
      currentHoverOverlayId: -1,
    };
  },
  created() {
    $eventsBus.$on("setStickerRotate", (id, value) => {
      this.setStickerRotate(id, value);
    });
    $eventsBus.$on("updateAllMoveables", () => {
      setTimeout(() => {
        this.updateAllMoveables();
      }, 50);
    });
  },
  mounted() {
    $eventsBus.$on("updateAnimation", (overlayId) => {
      this.updateAnimation(overlayId);
    });
    let rect = this.$refs.overlayObjectsControlBlock.getBoundingClientRect();
    this.overlayObjectsControlRect = { width: rect.width, height: rect.height };
    this.mounted = true;
  },
  updated() {
    let rect = this.$refs.overlayObjectsControlBlock.getBoundingClientRect();
    this.overlayObjectsControlRect.width = rect.width;
    this.overlayObjectsControlRect.height = rect.height;
  },
  computed: {
    isSafariBrowser: function () {
      let isSafariBrowser = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );
      return isSafariBrowser;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    items: function () {
      return this.$store.state.items;
    },
    showDownloadPanel: function () {
      return this.$store.state.showDownloadPanel;
    },
    contentVideoCurrentTime: function () {
      return this.$store.state.contentVideoCurrentTime;
    },
    isMultiSelectMode: function () {
      let checkedVariations = this.$store.state.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked);
      return (
        checkedVariations.length > 1 &&
        this.previewItem.currentVariation.checked
      );
    },
  },
  watch: {
    "previewItem.currentVariation.overlays": {
      handler: function () {
        //this.updateOverlaysMoveablesRects();
        //TODO тригер на изменения файла стикера
      },
      deep: true,
    },
    "previewItem.currentVariation.currentSize": {
      handler: function () {
        this.updateAllMoveables();
      },
      deep: true,
    },
    showDownloadPanel: function () {
      this.updateAllMoveables();
    },
    isPlaying: function () {
      this.syncOverlaysTimes();
    },
    contentVideoCurrentTime: function () {
      this.syncOverlaysTimes();
    },
  },
  methods: {
    updateAnimation(id) {
      const obj = "animation" + id;

      // Костыль для игнорирования ошибки отрисовки (Не находится ref анимации c первого раза)
      if (!this.$refs[obj]) {
        return null;
      }

      this.$refs[obj][0].updateAnimation();
    },
    onHover(overlay) {
      let moveable = this.getMoveableOverlayByKey(overlay.id);
      moveable.moveable.innerMoveable.moveable.moveable.controlBox.element.style.opacity = 1;
      this.currentHoverOverlayId = overlay.id;
    },
    leaveHover(overlay) {
      let moveable = this.getMoveableOverlayByKey(overlay.id);
      moveable.moveable.innerMoveable.moveable.moveable.controlBox.element.style.opacity = 0;
      this.currentHoverOverlayId = -1;
    },
    clickToEdit(event) {
      if (
        event.x === this.lastCursorPosition.x &&
        event.y === this.lastCursorPosition.y
      ) {
        this.textEditMode = true;
        event.target.focus();
        event.target.dispatchEvent(
          new MouseEvent("mousedown", {
            bubbles: true,
            cancelable: true,
            composed: true,
            clientX: event.clientX,
            clientY: event.clientY,
          })
        );
      }

      //this.click(event, true);
    },
    mousedown(event) {
      if (!this.textEditMode) {
        this.lastCursorPosition = { x: event.x, y: event.y };
      }
      if (this.textEditMode) {
        event.stopPropagation();
        event.target.contentEditable = true;
        event.target.focus();
      }
      //evt.preventDefault();
      /* if (!evt.target.focused) {
        evt.target.focus();
	  } */
    },
    blur(event, overlay) {
      let oldTextValue = overlay.value;
      let isDelete = false;
      event.target.contentEditable = false;
      this.textEditMode = false;
      let value = event.target.innerText;
      overlay.value = value.trim();
      event.target.innerHTML = overlay.value;
      this.updateMoveableRect("overlay", overlay.id);
      if (value.trim() === "") {
        let overlaysToUpdate = this.isBackside
          ? this.previewItem.currentVariation.overlaysOfBackside
          : this.previewItem.currentVariation.overlays;
        overlaysToUpdate.splice(overlaysToUpdate.indexOf(overlay), 1);
        isDelete = true;
      }
      this.changeCheckedItems(overlay, oldTextValue, isDelete);
      this.changeText(event, overlay);
      this.scaleOverlayRectangleTextFontSize(overlay);
      this.updateAllMoveables();
      //TODO MAD HOTFIX
      this.mounted = false;
      setTimeout(() => {
        let rect =
          this.$refs.overlayObjectsControlBlock.getBoundingClientRect();
        this.overlayObjectsControlRect = {
          width: rect.width,
          height: rect.height,
        };
        this.mounted = true;
        setTimeout(() => {
          this.updateAllMoveables();
        }, 2);
      }, 2);
    },
    changeText(event, overlay) {
      /* if (event.keyCode === 13) {
        event.preventDefault();
      } */
      //if (event.)
      //inputType: "insertParagraph";
      //let value = event.target.innerText;
      //overlay.valueLines[lineIndex] = value;
      //overlay.value = overlay.valueLines.join("\n");
      //overlay.value = value;
      //let pos = event.target.selectionStart;
      //event.target.innerHTML = value;
      //event.target.selectionStart = pos;

      event.target.parentElement.firstElementChild.innerText = JSON.parse(
        JSON.stringify(event.target.outerText)
      );

      this.updateMoveableRect(
        "overlay",
        overlay.id,
        JSON.parse(JSON.stringify(event.target.outerText))
      );
    },
    enterNewLine(e, overlay) {
      document.execCommand("insertLineBreak");
      e.preventDefault();
      this.changeText(e, overlay);
    },
    syncOverlaysTimes() {
      this.overlays.forEach((overlay) => {
        if (
          this.isItTextObject(overlay) ||
          this.isItShapeObject(overlay) ||
          !overlay.file ||
          (overlay.file.type !== "video" &&
            overlay.file.type !== "pixabay-video" &&
            !(overlay.file.type === "gif" && overlay.file.pathWebm) &&
            !overlay.file.type.startsWith("animation"))
        ) {
          return;
        }
        if (!this.isMoveableObjectInShowRange(overlay)) {
          return;
        }

        let overlayDuration = 0;
        let moveableComponent = this.getMoveableOverlayByKey(overlay.id);
        let variation = this.previewItem.currentVariation;

        if (
          overlay.file.type === "video" ||
          overlay.file.type === "pixabay-video" ||
          (overlay.file.type === "gif" &&
            overlay.file.pathWebm &&
            !this.isSafariBrowser)
        ) {
          let video = moveableComponent.$el.children[1].children[0]; //TODO Warning. Need refactor
          overlayDuration = overlay.file.duration
            ? overlay.file.duration
            : video.duration;

          if (this.isPlaying) {
            if (video.paused) {
              video.play();
            }
          } else {
            video.pause();
          }

          let overlayTimeToSet =
            ((this.contentVideoCurrentTime - overlay.startTime) /
              variation.speed) %
            video.duration;
          if (Math.abs(overlayTimeToSet - video.currentTime) > 0.5) {
            video.currentTime = overlayTimeToSet;
          }
        }

        if (overlay.file.type === "gif" && this.isSafariBrowser) {
          let gifComponent = moveableComponent.$children[0]; //TODO Warning. Need refactor
          overlayDuration = overlay.file.duration
            ? overlay.file.duration
            : gifComponent.duration;

          if (overlayDuration) {
            let overlayTimeToSet =
              ((this.contentVideoCurrentTime - overlay.startTime) /
                variation.speed) %
              overlayDuration;
            if (Math.abs(overlayTimeToSet - gifComponent.currentTime) > 0.5) {
              gifComponent.currentTime = overlayTimeToSet;
            }
          }
        }
        if (overlay.file.type.startsWith("animation")) {
          const obj = "animation" + overlay.id;
          // Костыль для игнорирования ошибки отрисовки (Не находится ref анимации c первого раза)
          if (!this.$refs[obj]) {
            return null;
          }

          if (this.contentVideoCurrentTime - overlay.startTime < 0) {
            return null;
          }
          const currentAnimationTime =
            (((this.contentVideoCurrentTime - overlay.startTime) /
              variation.speed) %
              (overlay.getAnimationPropAtPath(
                overlay.file.json,
                overlay.file.duration.main.op.path
              ) /
                overlay.getAnimationPropAtPath(
                  overlay.file.json,
                  overlay.file.fps.path
                ))) *
            1000;

          // 0.07 Погрешность времени для исключения появления начала перезапущенной анимации
          if (overlay.finishTime - this.contentVideoCurrentTime <= 0.07) {
            this.$refs[obj][0].goToAndStop(currentAnimationTime);
            return null;
          }
          if (this.isPlaying) {
            this.$refs[obj][0].goToAndPlay(currentAnimationTime);
          } else {
            this.$refs[obj][0].goToAndStop(currentAnimationTime);
          }
        }
      });
    },
    getOverlayTransform(overlay) {
      let transforms = overlay.transforms;
      return (
        "translate(" +
        (transforms.translateX ? transforms.translateX : 0) +
        "px, " +
        (transforms.translateY ? transforms.translateY : 0) +
        "px) " +
        "rotate(" +
        (transforms.rotate ? transforms.rotate : 0) +
        "deg) scale3d(" +
        (transforms.scaleX ? transforms.scaleX : 1) +
        ", " +
        (transforms.scaleY ? transforms.scaleY : 1) +
        ", 1)"
      );
    },
    getOverlayAnimationStyle(overlay) {
      if (
        overlay.variationId !== this.previewItem.currentVariation.id ||
        !overlay.animation ||
        (this.isItTextObject(overlay) && this.textEditMode)
      ) {
        return {};
      }
      let translate = "none";
      let opacity = 1;
      let transitionTime = 0;
      let overlayStartTime =
        overlay.startTime >= this.previewItem.currentVariation.cut.startTime
          ? overlay.startTime
          : this.previewItem.currentVariation.cut.startTime;
      let overlayFinishTime =
        overlay.finishTime <= this.previewItem.currentVariation.cut.finishTime
          ? overlay.finishTime
          : this.previewItem.currentVariation.cut.finishTime;
      if (
        Math.abs(overlayStartTime - this.contentVideoCurrentTime) <= 0.05 ||
        Math.abs(overlayFinishTime - this.contentVideoCurrentTime) <= 0.05
      ) {
        translate = this.getOverlayAnimationTranslate(
          overlay,
          overlay.animation.fadeIn.type,
          true
        );
        opacity = overlay.animation.fadeIn.type.animateAlpha ? 0 : 1;
        transitionTime = 0;
      } else if (overlayStartTime > this.contentVideoCurrentTime) {
        translate = this.getOverlayAnimationTranslate(
          overlay,
          overlay.animation.fadeIn.type,
          true
        );
        opacity = overlay.animation.fadeIn.type.animateAlpha ? 0 : 1;
        transitionTime = overlay.animation.fadeIn.time;
      } else if (
        overlayStartTime <= this.contentVideoCurrentTime &&
        overlayFinishTime >
          this.contentVideoCurrentTime + overlay.animation.fadeOut.time + 0.1
      ) {
        translate = "translate(0px, 0px) scale(1)";
        opacity = 1;
        transitionTime = overlay.animation.fadeOut.time;
      } else if (
        overlayFinishTime <=
        this.contentVideoCurrentTime + overlay.animation.fadeOut.time + 0.1
      ) {
        translate = this.getOverlayAnimationTranslate(
          overlay,
          overlay.animation.fadeOut.type,
          false
        );
        opacity = overlay.animation.fadeOut.type.animateAlpha ? 0 : 1;
        transitionTime = overlay.animation.fadeOut.time;
      }
      return {
        transition:
          "opacity " +
          transitionTime +
          "s ease-in" +
          ", transform " +
          transitionTime +
          "s ease-in",
        opacity: opacity,
        transform: translate,
      };
    },
    getOverlayAnimationTranslate(overlay, animationType, isFadeIn) {
      let initialDistance =
        animationType === "motion-right" || animationType === "motion-left"
          ? this.overlayObjectsControlRect.width +
            overlay.offsetDimensions.width
          : this.overlayObjectsControlRect.height +
            overlay.offsetDimensions.height;
      //TODO scale при разных scaleX и scaleY
      let translateValue =
        initialDistance /
        (overlay.transforms.scaleX && overlay.transforms.scaleY !== 0
          ? overlay.transforms.scaleX
          : 1);
      //TODO сделать поправку на сдвиг
      let translate = "none";
      switch (animationType.name) {
        case "none":
        case "alpha":
          break;
        case "motion-right":
          translate =
            "translate(" +
            (isFadeIn ? -1 : 1) *
              translateValue *
              Math.cos((overlay.transforms.rotate * Math.PI) / 180) +
            "px, " +
            (isFadeIn ? 1 : -1) *
              translateValue *
              Math.sin((overlay.transforms.rotate * Math.PI) / 180) +
            "px)";
          break;
        case "motion-left":
          translate =
            "translate(" +
            (isFadeIn ? 1 : -1) *
              translateValue *
              Math.cos((overlay.transforms.rotate * Math.PI) / 180) +
            "px, " +
            (isFadeIn ? -1 : 1) *
              translateValue *
              Math.sin((overlay.transforms.rotate * Math.PI) / 180) +
            "px)";
          break;
        case "motion-down":
          translate =
            "translate(" +
            (isFadeIn ? -1 : 1) *
              translateValue *
              Math.sin((overlay.transforms.rotate * Math.PI) / 180) +
            "px, " +
            (isFadeIn ? -1 : 1) *
              translateValue *
              Math.cos((overlay.transforms.rotate * Math.PI) / 180) +
            "px)";
          break;
        case "motion-up":
          translate =
            "translate(" +
            (isFadeIn ? 1 : -1) *
              translateValue *
              Math.sin((overlay.transforms.rotate * Math.PI) / 180) +
            "px, " +
            (isFadeIn ? 1 : -1) *
              translateValue *
              Math.cos((overlay.transforms.rotate * Math.PI) / 180) +
            "px)";
          break;

        case "zoom-in":
        case "zoom-out":
          translate = "scale(" + 0.1 / overlay.transforms.scaleX + ")";
          break;

        default:
          break;
      }
      return translate;
    },
    getLineBackground(text) {
      let converted = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        text.style.box.color
      );
      let rgb = converted
        ? {
            r: parseInt(converted[1], 16),
            g: parseInt(converted[2], 16),
            b: parseInt(converted[3], 16),
          }
        : { r: 0, g: 0, b: 0 };
      return (
        "rgba(" +
        rgb.r +
        ", " +
        rgb.g +
        ", " +
        rgb.b +
        ", " +
        text.style.opacity +
        ")"
      );
    },
    getLineBoxShadow(overlay) {
      let w = overlay.style.box.width;
      let color = this.getLineBackground(overlay);
      (" + color + ");
      let shadow =
        "-" +
        w +
        "px 0px 0 " +
        color +
        ", " +
        w +
        "px 0px 0 " +
        color +
        ", -" +
        w +
        "px -" +
        w +
        "px 0 " +
        color +
        ", " +
        w +
        "px " +
        w +
        "px 0 " +
        color +
        ", " +
        w +
        "px -" +
        w +
        "px 0 " +
        color +
        ", -" +
        w +
        "px " +
        w +
        "px 0 " +
        color +
        ", 0px -" +
        w +
        "px 0 " +
        color +
        ", " +
        "0px " +
        w +
        "px 0 " +
        color;
      return overlay.style.box.width === 0 ? "none" : shadow;
    },
    getMoveableOverlayByKey(key) {
      let id = key;
      return this.$refs["moveable-overlay" + id]
        ? this.$refs["moveable-overlay" + id][0]
        : null;
    },
    getMoveableOverlayTextBoxCanvasByKey(key) {
      let id = key;
      return this.$refs["textBoxCanvas" + id]
        ? this.$refs["textBoxCanvas" + id][0]
        : null;
    },
    getMoveableOverlayTextBoxImageByKey(key) {
      let id = key;
      return this.$refs["textBoxImage" + id]
        ? this.$refs["textBoxImage" + id][0]
        : null;
    },
    updateAllMoveables() {
      this.updateOverlaysMoveablesRects();
    },
    updateOverlaysMoveablesRects() {
      this.overlays.forEach((overlay) => {
        this.updateMoveableRect("overlay", overlay.id);
      });
      /*       this.previewItem.currentVariation.overlays.forEach((overlay) => {
        this.updateMoveableRect("overlay", overlay.id);
      }); */
    },
    updateMoveableRect(type, key?, textValue?) {
      let moveable = this.getMoveableOverlayByKey(key);

      if (moveable) {
        this.updateVariationMoveablesGuidelines();
        moveable.updateRect();
        let overlay = this.overlays.find((s) => s.id === key);
        this.updateOverlayData(overlay);

        if (this.isItTextObject(overlay)) {
          this.items.forEach((item) => {
            let v = item.variations.find((v) => v.id === overlay.variationId);
            if (/* v &&  */ !overlay.isRectangle) {
              this.getMoveableOverlayTextBoxImageByKey(overlay.id).src =
                overlay.updateTextBoxCanvas(
                  this.getMoveableOverlayTextBoxCanvasByKey(overlay.id),
                  overlay,
                  textValue
                );
            } else {
              this.scaleOverlayRectangleTextFontSize(overlay);
            }
          });
        }

        this.$forceUpdate();
        setTimeout(() => {
          this.updateOverlayData(overlay);
        }, 50);
      }
    },
    updateVariationMoveablesGuidelines(variation = null) {
      variation =
        variation === null ? this.previewItem.currentVariation : variation;
      let rect = this.$refs.overlayObjectsControlBlock.getBoundingClientRect();
      //5% from edges
      let verticalGuidelines = [
        rect.width * 0.05,
        rect.width / 2,
        rect.width * 0.95,
      ];
      let horizontalGuidelines = [
        rect.height * 0.05,
        rect.height / 2,
        rect.height * 0.95,
      ];
      variation.overlays.forEach((overlay) => {
        overlay.moveableObject.verticalGuidelines = verticalGuidelines.slice();
        overlay.moveableObject.horizontalGuidelines =
          horizontalGuidelines.slice();
      });
      variation.overlaysOfBackside.forEach((overlay) => {
        overlay.moveableObject.verticalGuidelines = verticalGuidelines.slice();
        overlay.moveableObject.horizontalGuidelines =
          horizontalGuidelines.slice();
      });
    },
    updateOverlayData(overlay) {
      let moveable = this.getMoveableOverlayByKey(overlay.id);
      if (!moveable) {
        return;
      }
      moveable.updateRect();
      let moveableRect = moveable.getRect();
      overlay.offsetDimensions = {
        width: moveableRect.offsetWidth,
        height: moveableRect.offsetHeight,
      };
    },
    //Handle moveables transformations
    snap(e, overlay) {
      if (e.guidelines.length !== 0) {
        //console.log(e);
        //console.log(overlay.moveableObject.verticalGuidelines);
        //console.log(overlay.moveableObject.horizontalGuidelines);
        //let rect = e.currentTarget.target.getBoundingClientRect();
        //let x = rect.x + rect.width / 2;
        //let y = rect.y + rect.height / 2;
        /*         if (this.clientXBefore - x <= 10) {
          overlay.transforms.translateX =
            this.translateXBefore + x - this.clientXBefore;
        }
        if (this.clientYBefore - y <= 10) {
          overlay.transforms.translateY =
            this.translateYBefore + y - this.clientYBefore;
        } */
      }
    },
    handleStartDrag(e, overlay) {
      /* let overlay = this.overlays.find(
        (s) => "overlay" + s.id === e.target.children[0].id
	  ); */
      this.translateXBefore = overlay.transforms.translateX;
      this.translateYBefore = overlay.transforms.translateY;
      if (e.inputEvent) {
        this.clientXBefore = e.clientX;
        this.clientYBefore = e.clientY;
      }
    },
    handleEndDrag(e, overlay) {
      this.$store.commit("addNewStateToHistory");
    },
    handleDrag(e, overlay) {
      /* let overlay = this.overlays.find(
        (s) => "overlay" + s.id === target.children[0].id
	  ); */
      if (!this.isOverlayCanMultiselectEdit(overlay, true)) {
        return;
      }
      let numberPattern = /-?\d+\.?\d*/g;
      let values = e.transform.match(numberPattern).map((t) => parseFloat(t));

      let oldTransform = this.getOverlayTransform(overlay);
      /*       overlay.transforms.translateX =
        this.translateXBefore + values[6] * overlay.transforms.scaleX;
      overlay.transforms.translateY =
		this.translateYBefore + values[7] * overlay.transforms.scaleX; */
      if (e.clientX === undefined) {
        return;
      }
      overlay.transforms.translateX =
        this.translateXBefore + e.clientX - this.clientXBefore;
      overlay.transforms.translateY =
        this.translateYBefore + e.clientY - this.clientYBefore;

      this.updateOverlayData(overlay);
      //snap
      let snapTrashhold = 2.5;
      let gY = overlay.moveableObject.horizontalGuidelines.find(
        (gY) => Math.abs(gY - e.top) <= snapTrashhold
      );
      let gX = overlay.moveableObject.verticalGuidelines.find(
        (gX) => Math.abs(gX - e.left) <= snapTrashhold
      );
      if (gY || gX) {
        if (gX) {
          overlay.transforms.translateX += gX - e.left;
          if (Math.abs(overlay.transforms.translateX) < 0.5) {
            overlay.transforms.translateX = 0;
          }
        }
        if (gY) {
          overlay.transforms.translateY += gY - e.top;
          if (Math.abs(overlay.transforms.translateY) < 0.5) {
            overlay.transforms.translateY = 0;
          }
        }
        this.updateOverlayData(overlay);

        setTimeout(() => {
          let moveable = this.getMoveableOverlayByKey(overlay.id);
          moveable.updateRect();
        }, 10);
      }

      this.changeCheckedItems(overlay, false, false, false, oldTransform, true);
    },
    handleStartScale(e, overlay) {
      /* let overlay = this.overlays.find(
        (s) => "overlay" + s.id === e.target.children[0].id
      ); */
      this.scaleXBefore = overlay.transforms.scaleX;
      this.scaleYBefore = overlay.transforms.scaleY;
    },
    handleEndScale(e, overlay) {
      this.$store.commit("addNewStateToHistory");
    },
    handleScale(e, overlay) {
      /* let overlay = this.overlays.find(
        (s) => "overlay" + s.id === e.target.children[0].id
      ); */
      if (!this.isOverlayCanMultiselectEdit(overlay)) {
        return;
      }
      let numberPattern = /-?\d+\.?\d*/g;
      let values = e.transform.match(numberPattern).map((t) => parseFloat(t));
      if (values[6] <= 0 || values[7] <= 0) {
        return;
      }

      let oldTransform = this.getOverlayTransform(overlay);
      overlay.transforms.scaleX = this.scaleXBefore * values[6];
      overlay.transforms.scaleY = this.scaleYBefore * values[7];
      this.updateOverlayData(overlay);
      this.changeCheckedItems(overlay, false, false, true, oldTransform);
    },
    handleEndRotate(e, overlay) {
      this.$store.commit("addNewStateToHistory");
    },
    handleRotate({ target, dist, transform, rotate, delta }, overlay) {
      /* let overlay = this.overlays.find(
        (s) => "overlay" + s.id === target.children[0].id
      ); */
      if (!this.isOverlayCanMultiselectEdit(overlay)) {
        return;
      }

      let oldTransform = this.getOverlayTransform(overlay);
      overlay.transforms.rotate += delta / 2;
      this.changeCheckedItems(
        overlay,
        false,
        false,
        false,
        oldTransform,
        false,
        true
      );

      //TODO метод почему-то вызывается два раза подряд. Поэтому делим значение пополам
    },
    setStickerRotate(id, value) {
      /*       let mov = this.getMoveableOverlayByKey(id);
      if (!mov) {
        return;
      }
      let requester = mov.request("rotatable");
      requester.request({ deltaRotate: value });
      requester.requestEnd();
      mov.updateRect();
      this.$forceUpdate(); */
    },
    scaleOverlayRectangleTextFontSize(overlay) {
      if (!this.isItTextObject(overlay) || !overlay.isRectangle) {
        return;
      }
      let moveableElement = this.getMoveableOverlayByKey(overlay.id).$el;
      let textSpan = moveableElement.children[1].firstChild; //TODO Warning. Need refactor
      let recursionStoper = 0;
      while (
        this.checkAndScaleOverlayRectangleTextFont(
          moveableElement,
          textSpan,
          overlay
        )
      ) {
        recursionStoper++;
        if (recursionStoper === 100) {
          break;
        }
      }
    },
    checkAndScaleOverlayRectangleTextFont(
      containerNode,
      textContainerNode,
      overlay
    ) {
      let width = containerNode.clientWidth;
      let height = containerNode.clientHeight;
      let innerHeight = textContainerNode.clientHeight;
      let innerWidth = textContainerNode.clientWidth;

      let fontSize = overlay.style.size.value;

      let isIncrement = false;

      if (height < innerHeight || width < innerWidth) {
        //scale down
        isIncrement = false;
      } else if (height > innerHeight || width > innerWidth) {
        //scale up
        isIncrement = true;
      } else {
        return false;
      }

      let size = isIncrement ? fontSize + 1 : fontSize - 1;
      overlay.style.size = {
        name: size + "px",
        title: size + " px",
        value: size,
      };
      overlay.style.height = {
        name: size + 5 + "px",
        title: size + 5 + " px",
        value: size + 5,
      };
      textContainerNode.style.fontSize = Math.ceil(size) + "px";
      textContainerNode.style.lineHeight = Math.ceil(size + 5) + "px";

      let isChanged = true;

      width = containerNode.clientWidth;
      height = containerNode.clientHeight;
      innerHeight = textContainerNode.clientHeight;
      innerWidth = textContainerNode.clientWidth;
      if (isIncrement && (height < innerHeight || width < innerWidth)) {
        //scale down - rollback
        isChanged = false;

        let size = fontSize - 1;
        overlay.style.size = {
          name: size + "px",
          title: size + " px",
          value: size,
        };
        overlay.style.height = {
          name: size + 5 + "px",
          title: size + 5 + " px",
          value: size + 5,
        };
        textContainerNode.style.fontSize = Math.ceil(size) + "px";
        textContainerNode.style.lineHeight = Math.ceil(size + 5) + "px";
      }

      return isChanged;
    },
    //-- TODO from this
    handleResize(e, overlay) {
      if (!this.isOverlayCanMultiselectEdit(overlay)) {
        return;
      }
      let isChanged = false;
      if (overlay.moveabaleStyle.width !== e.width + "px") {
        overlay.moveabaleStyle.width = `${e.width}px`;
        e.target.style.width = `${e.width}px`;
        isChanged = true;
      }
      if (overlay.moveabaleStyle.height !== e.height + "px") {
        overlay.moveabaleStyle.height = `${e.height}px`;
        e.target.style.height = `${e.height}px`;
        isChanged = true;
      }
      if (isChanged) {
        this.updateOverlayData(overlay);
        this.scaleOverlayRectangleTextFontSize(overlay);
        this.changeCheckedItems(
          overlay,
          false,
          false,
          false,
          null,
          false,
          false,
          true
        );
      }
    },
    handleWarp({ target, transform }) {
      target.style.transform = transform;
    },
    handlePinch({ target }) {},
    //-- TODO to this
    getMoveableScale(transform) {
      if (transform === "") {
        return 1;
      }
      let numberPattern = /-?\d+\.?\d*/g;
      let values = transform.match(numberPattern).map((t) => parseFloat(t));
      let scaleX = values[0];
      return Math.abs(scaleX * (transform.includes("scale") ? values[6] : 1));
    },
    onResize(e) {
      let rect = this.$refs.overlayObjectsControlBlock.getBoundingClientRect();
      let difference = rect.width / this.overlayObjectsControlRect.width;
      this.overlayObjectsControlRect = {
        width: rect.width,
        height: rect.height,
      };
      if (difference === 1 || difference === Infinity) {
        this.updateAllMoveables();
        return;
      }
      /*
      this.items.forEach((item) => {
        item.variations.forEach((variation) => {
          variation.overlays */
      this.overlays.forEach((overlay) => {
        let mov = this.getMoveableOverlayByKey(overlay.id);
        if (mov) {
          //TODO
          if (this.isItTextObject(overlay)) {
            overlay.transforms.scaleX *= difference;
            overlay.transforms.scaleY *= difference;
            overlay.transforms.translateX *= difference;
            overlay.transforms.translateY *= difference;
          } else {
            //this.updateMoveableAfterResize(mov, difference);
            overlay.transforms.translateX =
              overlay.transforms.translateX * difference;
            overlay.transforms.translateY =
              overlay.transforms.translateY * difference;
          }
          this.updateOverlayData(overlay);
        }
      });
      /*         });
      }); */
      this.updateAllMoveables();
    },
    updateMoveableAfterResize(mov, difference) {
      let moveableRect = mov.getRect();
      mov.updateRect();
      this.$forceUpdate();
      let requester = mov.request("draggable");
      requester.request({
        x: moveableRect.left * difference,
        y: moveableRect.top * difference,
      });
      requester.requestEnd();

      mov.updateRect();
      this.$forceUpdate();
    },
    updateMoveableTextAfterResize(mov, difference) {
      let moveableRect = mov.getRect();

      mov.updateRect();
      this.$forceUpdate();
      let requesterScale = mov.request("scalable");
      requesterScale.request({
        deltaWidth:
          moveableRect.offsetWidth * difference - moveableRect.offsetWidth,
        deltaHeight:
          moveableRect.offsetHeight * difference - moveableRect.offsetHeight,
      });
      requesterScale.requestEnd();

      mov.updateRect();
      this.$forceUpdate();
      let requesterDrag = mov.request("draggable");
      requesterDrag.request({
        x: moveableRect.left * difference,
        y: moveableRect.top * difference,
      });
      requesterDrag.requestEnd();

      mov.updateRect();
      this.$forceUpdate();
    },
    isMoveableObjectInShowRange(object) {
      if (object.variationId !== this.previewItem.currentVariation.id) {
        return false;
      }
      return (
        !object.isCustomTime ||
        (object.isCustomTime &&
          object.startTime <= this.contentVideoCurrentTime &&
          object.finishTime >= this.contentVideoCurrentTime)
      );
    },
    openToolInToolsPanel(name) {
      $eventsBus.$emit("openToolInToolsPanel", name);
    },
    changeCheckedItems(
      overlay,
      oldTextValue,
      isDelete,
      isScale,
      oldTransform,
      isDrag,
      isRotate,
      isResize
    ) {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      return this.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked)
        .forEach((v) => {
          let sameOverlays = [];
          v.getAllOverlays()
            .filter((o) => {
              let currentTransform = this.getOverlayTransform(overlay);
              let oTransfom = this.getOverlayTransform(o);
              let isSameTransform =
                isScale || isDrag || isRotate
                  ? oTransfom === oldTransform
                  : oTransfom === currentTransform;
              return (
                (this.isItTextObject(overlay)
                  ? oldTextValue
                    ? oldTextValue === o.value
                    : o.value === overlay.value
                  : this.isItAnimationObject(overlay)
                  ? o?.file?.id && o.file.id === overlay.file.id
                  : JSON.stringify(o.file) ===
                    JSON.stringify(overlay.file)) /*TODO need check it */ &&
                o.id !== overlay.id &&
                o.twinnedId === overlay.twinnedId
                /*                 isSameTransform &&
                o.position === overlay.position &&
                (isDrag
                  ? this.previewItem.currentVariation.currentSize.name ===
                    v.currentSize.name
                  : true) */
              );
            })
            .forEach((o) => {
              if (oldTextValue) {
                o.value = overlay.value;
              }
              if (isScale) {
                o.transforms.scaleX = overlay.transforms.scaleX;
                o.transforms.scaleY = overlay.transforms.scaleY;
                this.updateOverlayData(o);
              }
              if (isDrag) {
                if (o.position !== overlay.position) {
                  $eventsBus.$emit("updateOverlayPosition", o, false, false);
                }
                let videoPreviewPixelsWidth =
                  this.$store.getters.videoPreviewPixelsWidth;
                let videoPixelsHeight =
                  (videoPreviewPixelsWidth /
                    v.previewParameters.outerVideoResolutionX) *
                  v.previewParameters.outerVideoResolutionY;

                let k =
                  (videoPixelsHeight - overlay.offsetDimensions.height) /
                  (this.overlayObjectsControlRect.height -
                    overlay.offsetDimensions.height);

                o.transforms.translateX = overlay.transforms.translateX;
                o.transforms.translateY = overlay.transforms.translateY * k;
                this.updateOverlayData(o);
              }
              if (isRotate) {
                o.transforms.rotate = overlay.transforms.rotate;
              }
              if (isResize) {
                o.moveabaleStyle.width = overlay.moveabaleStyle.width;
                o.moveabaleStyle.height = overlay.moveabaleStyle.height;
                this.scaleOverlayRectangleTextFontSize(o);
                this.updateOverlayData(o);
              }
              if (isDelete) {
                sameOverlays.push(o);
              }
            });
          sameOverlays.forEach((o) => {
            let overlaysToUpdate =
              v.overlays.indexOf(o) !== -1 ? v.overlays : v.overlaysOfBackside;
            if (isDelete) {
              overlaysToUpdate.splice(overlaysToUpdate.indexOf(o), 1);
            }
          });
        });
    },
    isOverlayCanMultiselectEdit(overlay, isCanDrag) {
      if (!this.previewItem.currentVariation.checked) {
        return true;
      }
      return this.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked && v !== this.previewItem.currentVariation)
        .every((v) => {
          return v.getAllOverlays().some((o) => {
            return (
              (this.isItTextObject(overlay)
                ? o.value === overlay.value &&
                  o.isRectangle === overlay.isRectangle
                : this.isItAnimationObject(overlay)
                ? o?.file?.id && o.file.id === overlay.file.id
                : JSON.stringify(o.file) ===
                  JSON.stringify(overlay.file)) /*TODO need check it */ &&
              o.twinnedId === overlay.twinnedId
              /*               this.getOverlayTransform(overlay) ===
                this.getOverlayTransform(o) &&
              o.position === overlay.position &&
              (isCanDrag
                ? this.previewItem.currentVariation.currentSize.name ===
                  v.currentSize.name
                : true) */
            );
          });
        });
    },
    isItTextObject(overlayObject) {
      return overlayObject.type === "text";
    },
    isItShapeObject(overlayObject) {
      return overlayObject.type === "shape";
    },
    isItAnimationObject(overlayObject) {
      return overlayObject.type === "animation";
    },
  },
});
